import { render } from "./Features.vue?vue&type=template&id=91fa145c"
const script = {}

import "./Features.vue?vue&type=style&index=0&id=91fa145c&lang=scss"
script.render = render

export default script